import React from 'react';
import {MasterLayout} from 'layout';
import { header } from 'constants/table';
import {ThongKeBaoCao} from 'api';
import DataTable from 'components/data-table';
import {RowItemBaoCaoDinhKyChiTiet} from './datatable';
import {ContainerFileDinhKem} from 'components/upload';
import {browserHistory} from 'react-router';
import { Button } from '@blueprintjs/core';
import {ConfirmDialog} from 'modules/dialog';
import { msg } from "constants/message";
import { Toastr } from 'modules/toastr';
import { connect } from 'react-redux';
import moment from 'moment';

class BaoCaoDinhKyChiTiet extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {},
        trangThaiBaoCao: false
      },
      loaiBaoCao: [],
      taiLieuBaoCao: [],
      taiLieuBaoCaoUpdate: [],
      taiLieuBaoCaoDelete: [],
      dataFileDinhKemDelete: [],
      tableLoading: false,
      dataFileDinhKem: [],
      hasChange: false,
      backConfirm: false
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id != this.props.params.id) {
      this.getInfo(nextProps.params.id);
      this.getLoaiBaoCaoList(nextProps.params.id);
    }
  }
  componentDidMount() {
    if (this.props.params.id) {
      this.getInfo(this.props.params.id);
      this.getLoaiBaoCaoList(this.props.params.id);
    }
  }

  getInfo(idBC) {
    ThongKeBaoCao.actions.getBaoCaoDinhKyChiTiet.request({id: idBC}).then(res => {
      if (res.data) {
        res.data.listTaiLieuBaoCao.map(item => {
          item.soQuyetDinh = item.soVanBan;
          item.ngayQuyetDinh = item.ngayRaVanBan;
          return item;
        })
        this.setState({
          data: res.data
        });
      }
    });
  }
  getLoaiBaoCaoList(idBC) {
    this.setState({tableLoading: true});
    ThongKeBaoCao.actions.getBaoCaoDinhKyLoaiDon.request({id: idBC}).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({
          loaiBaoCao: res.data._embedded.baoCaoDonViChiTiets,
          tableLoading: false
        });
      }
    });
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data,
      hasChange: true
    });
  }

  onFileRemove(id, data) {
    this.state.dataFileDinhKemDelete = [
      ...this.state.dataFileDinhKemDelete,
      id
    ];
    this.state.dataFileDinhKem = data;
    this.state.hasChange = true;
    this.forceUpdate();
  }

  handleBack(allowBack) {
    if (allowBack) {
      this.props.dispatch({type: 'BCDK_GO_BACK'});
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        this.props.dispatch({type: 'BCDK_GO_BACK'});
        browserHistory.goBack();
      }
    }
  }
  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }
  guiBaoCao() {
    this.setState({posting: true});
    this.pushTaiLieuDinhKem();
    ThongKeBaoCao.actions.guiBaoCaoDinhKy.request({id: this.state.data.baoCaoDonViId}).then(res => {
      if (res.data) {
        Toastr(msg.guiBCSuccess, 'success');
        setTimeout(() => {
          browserHistory.goBack();
        }, 1000);
      }
      this.setState({posting: false});
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      this.setState({
        posting: false
      });
    });
  }
  postTaiLieuBC(params) {
    ThongKeBaoCao.actions.postTaiLieuBaoCao.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }
  updateTaiLieuBC(params) {
    ThongKeBaoCao.actions.updateTaiLieuBaoCao.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }
  deletetaiLieuBC(params) {
    ThongKeBaoCao.actions.deleteTaiLieuBaoCao.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }
  LuuBaoCao(type) {
    this.pushTaiLieuDinhKem();
    this.handleBack(true);
    Toastr(msg.dkLuuHoSo, 'success');
  }
  pushTaiLieuDinhKem(){
    let dataFileDinhKem = [...this.state.dataFileDinhKem];
    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuBaoCaoId) {
          this.state.taiLieuBaoCaoUpdate[this.state.taiLieuBaoCaoUpdate.length] = {
            baoCaoDonVi: {
              id: Number(this.props.params.id)
            },
            id: item.taiLieuBaoCaoId,
            ten: item.ten,
            soVanBan: item.soQuyetDinh,
            ngayRaVanBan: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : '',
            tenFile: item.tenFile,
            urlFile: item.duongDan,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuBaoCao[this.state.taiLieuBaoCao.length] = {
            baoCaoDonVi: {
              id: Number(this.props.params.id)
            },
            ten: item.ten,
            soVanBan: item.soQuyetDinh,
            ngayRaVanBan: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : '',
            tenFile: item.tenFile,
            urlFile: item.duongDan,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });
    }
    if (this.state.dataFileDinhKemDelete.length > 0) {
      this.state.dataFileDinhKemDelete.map((item, index) => {
        this.state.taiLieuBaoCaoDelete[index] = {
          id: item
        };
      });
    }
    if(this.state.taiLieuBaoCao.length > 0) {
      let params = {
        taiLieuBaoCaos: this.state.taiLieuBaoCao
      }
      this.postTaiLieuBC(params);
    }
    if(this.state.taiLieuBaoCaoUpdate.length > 0) {
      let params = {
        taiLieuBaoCaos: this.state.taiLieuBaoCaoUpdate
      }
      this.updateTaiLieuBC(params);
    }

    if(this.state.taiLieuBaoCaoDelete.length > 0) {
      let params = {
        taiLieuBaoCaos: this.state.taiLieuBaoCaoDelete
      }
      this.deletetaiLieuBC(params);
    }
  }

  goBack() {
    this.props.dispatch({type: 'BCDK_GO_BACK'});
    browserHistory.goBack();
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
          <div className="back-foward mb0">
            <span className='arrow-left txt-blue txt-underline' onClick={this.goBack.bind(this)}>Về trang trước</span>
          </div>
          <div className="top-content">
            <div className="left-content">
                <p className="title-18"><i className="tt tt-thongke"></i>Báo cáo định kỳ {this.state.data.baoCaoTongHopInfo.kyBaoCaoInfo || ''} năm {this.state.data.baoCaoTongHopInfo.namBaoCao || ''}</p>
            </div>
          </div>
          <div className="bottom-content thongke-content">
            <div className='row pl10 pr10'>
              <h2 className='title-14 col-100 pt20 pl20 pr20'>1. Danh sách biểu mẫu</h2>
            </div>
            <div className="wrap-table clear-left">
              <DataTable
                header={header.baoCaoDinhKyChiTiet}
                dataList={this.state.loaiBaoCao}
                hidePagination
                parent={this}
                hideButtonExport
                tableLoading={this.state.tableLoading}
              >
                <RowItemBaoCaoDinhKyChiTiet/>
              </DataTable>
            </div>
            <div className='row pl15 pr15 pb15'>
              <span className='big-border'></span>
            </div>
            <div className='row pl30 pr30 '>
              <ContainerFileDinhKem label="2. Danh sách văn bản xử lý" labelClass="title-14" disableTopLine={true} bindValidator={this} data={this.state.data.listTaiLieuBaoCao} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} disableAttachFile={this.state.data.trangThaiBaoCao == 'DA_GUI'}/>
            </div>
          </div>
          <div className="pt30">
            <div className="box-bottom">
              <Button type="button" className="btn-action btn-close" onClick={ this.handleBack.bind(this, false) }><span>Đóng</span></Button>
              {
                (!this.state.readOnly && this.state.data.trangThaiBaoCao != 'DA_GUI') &&
                <Button type="button" className={`btn-action btn-save btn-green ${this.state.posting ? 'btn-loading-inline' : ''}`} onClick={this.LuuBaoCao.bind(this, 'save')}>Lưu</Button>
              }
              {
                (this.state.data.daTongHopDu && this.state.data.trangThaiBaoCao != 'DA_GUI') &&
                <Button type="button" style={{right:0}} className={`btn-action btn-move btn-green right ${this.state.posting ? 'btn-loading-inline' : ''}`}                 onClick={this.guiBaoCao.bind(this)}>Gửi báo cáo</Button>
              }
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

BaoCaoDinhKyChiTiet.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

export default connect()(BaoCaoDinhKyChiTiet);


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-dinh-ky/BaoCaoDinhKyChiTiet.jsx